import { TransformDate } from '../../../shared/decorators/transform-date.decorator';
import { TransformFloat } from '../../../shared/decorators/transform-float.decorator';
import { PricingItemTypeEnum } from '../../../shared/modules/pricing-items/enums/pricing-item-type.enum';
import { ApiRequestFilters } from '../../../shared/types/api-request-filters';
import { VehicleMaintenanceRecordCategoryEnum } from '../enums/vehicle-maintenance-record-category.enum';
import { VehicleMaintenanceStatusEnum } from '../enums/vehicle-maintenance-status.enum';

/**
 * Vehicle maintenances filters
 */
export class VehicleMaintenancesFilters extends ApiRequestFilters {
	/**
	 * Customers id values
	 */
	customers?: number[];

	/**
	 * Suppliers id values
	 */
	suppliers?: number[];

	/**
	 * Vehicles id values
	 */
	vehicles?: number[];

	/**
	 * Rental Agreements id values
	 */
	rentalAgreements?: number[];

	/**
	 * Vehicle Damages id values
	 */
	vehicleDamages?: number[];

	/**
	 * Vehicle Road Worthy Checks id values
	 */
	vehicleRoadWorthyChecks?: number[];

	/**
	 * Estimated cost from
	 */
	@TransformFloat()
	estimatedCostFrom?: number;

	/**
	 * Estimated cost from
	 */
	@TransformFloat()
	estimatedCostTo?: number;

	/**
	 * Gross amount from
	 */
	@TransformFloat()
	totalGrossFrom?: number;

	/**
	 * Gross amount from
	 */
	@TransformFloat()
	totalGrossTo?: number;

	/**
	 * Check-out from date
	 */
	@TransformDate()
	startsAtFrom?: Date;

	/**
	 * Check-out to date
	 */
	@TransformDate()
	startsAtTo?: Date;

	/**
	 * Check-in from date
	 */
	@TransformDate()
	endsAtFrom?: Date;

	/**
	 * Check-in to date
	 */
	@TransformDate()
	endsAtTo?: Date;

	/**
	 * Individual dates that are contained within the StartsAt and EndsAt period
	 */
	@TransformDate()
	containsDates?: Date[];

	/**
	 * Check-out locations id values
	 */
	checkOutLocations?: number[];

	/**
	 * Check-in locations id values
	 */
	checkInLocations?: number[];

	/**
	 * Pricing item types id values
	 */
	pricingItemTypes?: PricingItemTypeEnum[];

	/**
	 * Status values
	 */
	statuses?: VehicleMaintenanceStatusEnum[];

	/**
	 * Record category enum values
	 */
	recordCategories?: VehicleMaintenanceRecordCategoryEnum[];

	/**
	 * Vehicle category id values
	 */
	vehicleCategories?: number[];

	/**
	 * Tag id values
	 */
	tags?: number[];
}
